var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhoarewe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1175,
    height: 1019,
    viewBox: "0 0 1175 1019",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.5 587C898.5 688.068 819.569 770 722.204 770C624.838 770 559 688.068 559 587C559 485.932 624.838 404 722.204 404C819.569 404 898.5 485.932 898.5 587Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M892.204 422.5C892.204 503.134 826.522 568.5 745.5 568.5C664.478 568.5 659.204 503.134 659.204 422.5C659.204 341.866 664.478 276.5 745.5 276.5C826.522 276.5 892.204 341.866 892.204 422.5Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729 527C729 607.634 663.319 673 582.296 673C501.274 673 496 607.634 496 527C496 446.366 501.274 381 582.296 381C663.319 381 729 446.366 729 527Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_31_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.5 571C509.5 651.634 443.819 717 362.796 717C281.774 717 276.5 651.634 276.5 571C276.5 490.366 281.774 425 362.796 425C443.819 425 509.5 490.366 509.5 571Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_106",
    x: 282.6,
    y: 127.6,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31_106",
    x: 382.804,
    y: 0.100006,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31_106",
    x: 219.6,
    y: 104.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31_106",
    x: 0.100006,
    y: 148.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_106"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoarewe);
export default __webpack_public_path__ + "static/media/whoarewe.523af79f601f8ab5ee8977031af4f695.svg";
export { ForwardRef as ReactComponent };